import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchHarvestProcess(producer_id, harvest_process_id) {
    return RequesterV1.get(
      `producer/projections/estimated_harvest/manage_estimated_harvest/${producer_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },

  fetchEstimatedHarvest(producer_id, estimated_harvest_id) {
    return RequesterV1.get(
      `producer/projections/estimated_harvest/manage_estimated_harvest/${producer_id}/fetch_estimated_harvest/${estimated_harvest_id}`
    );
  },

  fetchCropFields(producer_id, harvest_process_id) {
    return RequesterV1.get(
      `producer/projections/estimated_harvest/manage_estimated_harvest/${producer_id}/fetch_crop_fields/${harvest_process_id}`
    );
  },

  fetchHarvestProcessCropPackages(producer_id, harvest_process_id) {
    return RequesterV1.get(
      `producer/projections/estimated_harvest/manage_estimated_harvest/${producer_id}/fetch_harvest_process_crop_packages/${harvest_process_id}`
    );
  },

  fetchHarvestProcessCropSizeGroups(producer_id, harvest_process_id) {
    return RequesterV1.get(
      `producer/projections/estimated_harvest/manage_estimated_harvest/${producer_id}/fetch_harvest_process_crop_size_groups/${harvest_process_id}`
    );
  },

  create(producer_id, harvest_process_id, estimated_harvest) {
    return RequesterV1.post(
      `producer/projections/estimated_harvest/manage_estimated_harvest/${producer_id}/create/${harvest_process_id}`,
      { estimated_harvest: estimated_harvest }
    );
  },

  update(producer_id, estimated_harvest_id, estimated_harvest) {
    return RequesterV1.post(
      `producer/projections/estimated_harvest/manage_estimated_harvest/${producer_id}/update/${estimated_harvest_id}`,
      { estimated_harvest: estimated_harvest }
    );
  },

  destroy(producer_id, estimated_harvest_id) {
    return RequesterV1.delete(
      `producer/projections/estimated_harvest/manage_estimated_harvest/${producer_id}/destroy/${estimated_harvest_id}`
    );
  }
};
